const reportCurrencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const escapeCsvValue = (value: string) => {
  if (!/[",\n]/.test(value)) {
    return value;
  }

  return `"${value.replace(/"/g, '""')}"`;
};

const dispatchDownloadClick = (anchor: HTMLAnchorElement) => {
  anchor.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  );
};

export const formatReportCsvCurrencyValue = (value?: number | null) =>
  typeof value === "number" ? reportCurrencyFormatter.format(value) : "-";

export const stringifyReportCsvValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }

  if (Array.isArray(value)) {
    return value
      .map((item) => stringifyReportCsvValue(item))
      .filter(Boolean)
      .join(", ");
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "bigint"
  ) {
    return String(value);
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  return JSON.stringify(value);
};

export const buildReportCsvContent = ({
  headers,
  rows,
}: {
  headers: string[];
  rows: string[][];
}) =>
  [
    headers.map((header) => escapeCsvValue(header)).join(","),
    ...rows.map((row) => row.map((value) => escapeCsvValue(value)).join(",")),
  ].join("\n");

export const downloadReportCsvFile = ({
  content,
  fileName,
}: {
  content: string;
  fileName: string;
}) => {
  const normalizedFileName = fileName.endsWith(".csv")
    ? fileName
    : `${fileName}.csv`;
  const blob = new Blob([`\uFEFF${content}`], {
    type: "text/csv;charset=utf-8",
  });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.download = normalizedFileName;
  anchor.rel = "noopener";
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  window.setTimeout(() => {
    dispatchDownloadClick(anchor);
  }, 0);
  window.setTimeout(() => {
    if (anchor.isConnected) {
      document.body.removeChild(anchor);
    }
    window.URL.revokeObjectURL(url);
  }, 30_000);
};
